import modal from '@/utils/modal';

import { defineAsyncComponent } from 'vue';

const Conversation = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/components/DirectMessages/Conversation');
});

var ua = window.navigator.userAgent;
var iOS = ua.match(/iPad/i) || ua.match(/iPhone/i);
var webkit = ua.match(/WebKit/i);
var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

export default function openConversation (otherMerchantCustomerId) {
    const m = modal.create(Conversation, true, {
        provide: {
            otherMerchantCustomerId,
        },
    });
    m.body.classList.add('gmf-dm-conversation-modal');
    if (iOSSafari) {
        m.body.classList.add('gmf-safari');
    }
}
